'use strict';
angular.module('schoolLinqApp').factory('userService', [
	'$http',
	function ($http) {
		const endpoint = '/api/user';

		function list(userFilterModel) {
			return $http.post(endpoint + '/list', userFilterModel);
		}

		return {
			list: list,
		};
	},
]);
